import React from 'react';
import { Stage, Layer } from 'react-konva';

import DefaultFlagIcon from './DefaultFlagIcon';
import { isNotEmpty } from '../../lib/ep';

const SVGAnimationCommon = ({ cell_color, grid_color, ...props }) => {
	return (
		<div class="svg_minesweeper_controls gui_pos_rel" style={{ zIndex:'2' }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
				<g id="controls-rest-background">
					<path
						style={{ fill:cell_color }}
						d="M0,0v100h100V0H0z M70,70H30V30h40V70z"
					/>
				</g>

				<g id="controls-cell-background">
					<rect
						style={{ fill:cell_color }}
						x="30" y="30"
						width="40"
						height="40"
					/>
				</g>

				<g id="controls-grid">
					<line
						class="svg_fill_none svg_stroke_defs"
						stroke={grid_color}
						x1="0" y1="30"
						x2="100" y2="30"
					/>

					<line
						class="svg_fill_none svg_stroke_defs"
						stroke={grid_color}
						x1="0" y1="70"
						x2="100" y2="70"
					/>

					<line
						class="svg_fill_none svg_stroke_defs"
						stroke={grid_color}
						x1="30" y1="0"
						x2="30" y2="100"
					/>

					<line
						class="svg_fill_none svg_stroke_defs"
						stroke={grid_color}
						x1="70" y1="0"
						x2="70" y2="100"
					/>
				</g>

				{props.children}
			</svg>
		</div>
	)
};

const SVGAnimationMobile = ({ action, text_color, cell_color, grid_color, ...props }) => {
	return (
		<SVGAnimationCommon
			cell_color={cell_color}
			grid_color={grid_color}
		>
			<g id="controls-outter-click-circle">
				<circle
					class="svg_fill_none"
					cx="50"
					cy="50"
					r="16"
				/>

				<path
					class="svg_fill_none svg_stroke_defs svg_stroke_highlight"
					d="M42.11,39.25c2.21-1.62,4.93-2.58,7.89-2.58c7.36,0,13.33,5.97,13.33,13.33c0,1.8-0.36,3.52-1.01,5.09"
				/>

				<path
					class="svg_fill_none svg_stroke_defs svg_stroke_highlight"
					d="M41.65,60.4c-3.04-2.44-4.99-6.19-4.99-10.4c0-2.64,0.77-5.11,2.1-7.18"
				/>
			</g>

			<g id="controls-inner-click-circle">
				<circle
					class="svg_fill_none"
					cx="50"
					cy="50"
					r="16.5"
				/>

				<path
					class="svg_fill_none svg_stroke_defs svg_stroke_highlight"
					d="M42.27,54.92c-0.91-1.42-1.43-3.11-1.43-4.92c0-5.06,4.1-9.17,9.17-9.17s9.17,4.1,9.17,9.17c0,1.65-0.44,3.21-1.21,4.55"
				/>
			</g>

			<g id="controls-number">
				<path
					class="svg_stroke_none"
					fill={text_color}
					d="M43.57,54.69h1.95c0.13,1.01,0.57,1.84,1.29,2.49s1.75,0.98,3.05,0.98c1.39,0,2.49-0.36,3.29-1.07c0.8-0.71,1.19-1.63,1.17-2.77c-0.02-1.13-0.43-2.03-1.24-2.7c-0.81-0.67-1.9-1-3.29-1h-1.94v-1.9h1.81c1.16,0,2.1-0.33,2.83-1c0.73-0.66,1.08-1.51,1.08-2.54c-0.01-1-0.35-1.81-1.03-2.43c-0.68-0.62-1.59-0.93-2.73-0.93c-0.61,0-1.15,0.1-1.63,0.3c-0.48,0.2-0.86,0.46-1.14,0.79c-0.28,0.33-0.5,0.68-0.65,1.04c-0.15,0.37-0.24,0.75-0.27,1.14h-2.07c0.01-0.61,0.14-1.21,0.38-1.8c0.24-0.59,0.6-1.13,1.05-1.64c0.46-0.5,1.06-0.91,1.82-1.21C48.06,40.15,48.9,40,49.82,40c1.74,0,3.15,0.46,4.22,1.38c1.08,0.92,1.63,2.08,1.67,3.48c0.03,1.26-0.34,2.33-1.1,3.2c-0.76,0.87-1.58,1.37-2.46,1.51v0.03c0.45,0.04,0.9,0.16,1.37,0.37c0.47,0.21,0.92,0.49,1.36,0.85c0.44,0.36,0.8,0.84,1.08,1.45c0.28,0.6,0.43,1.28,0.45,2.02c0.03,1.64-0.58,3-1.84,4.09C53.34,59.46,51.74,60,49.8,60c-1.94,0-3.45-0.5-4.52-1.51C44.2,57.48,43.63,56.22,43.57,54.69z"
				/>
			</g>

			<g id="controls-hand-no-click">
				<path
					class="svg_fill_black svg_stroke_black svg_stroke_defs"
					d="M73.92,59.21l0-0.01l-2.02-2.02l-0.22,1.18c-1.77,0.03-3.19,1.48-3.19,3.26c0-1.8-1.46-3.27-3.25-3.27S62,59.82,62,61.63c0-1.8-1.46-3.27-3.25-3.27s-3.25,1.46-3.25,3.27V46.93c0-0.91-0.37-1.73-0.96-2.32l0,0l-2.16-2.15l-0.12,1.2c0,0-0.01,0-0.01,0c-1.79,0-3.25,1.46-3.25,3.27v16.42c-2.87,0-5,1.14-5,3.91v10.41c0,0.24,0.02,0.48,0.05,0.71l-0.65,1.12l2.37,2.4c0,0,0,0,0,0l0,0h0c1.09,1.09,2.59,1.76,4.23,1.76h18.5c3.58,0,6.5-2.94,6.5-6.53V61.63C75,60.67,74.58,59.81,73.92,59.21z"
				/>

				<path
					class="svg_fill_white svg_stroke_black svg_stroke_defs"
					d="M66.5,81.67c3.58,0,6.5-2.94,6.5-6.53V59.63c0-1.8-1.46-3.27-3.25-3.27s-3.25,1.46-3.25,3.27c0-1.8-1.46-3.27-3.25-3.27S60,57.82,60,59.63c0-1.8-1.46-3.27-3.25-3.27s-3.25,1.46-3.25,3.27V44.93c0-1.8-1.46-3.27-3.25-3.27S47,43.13,47,44.93v16.42c-2.87,0-5,1.14-5,3.91v10.41c0,3.3,2.7,6,6,6H66.5z"
				/>

				<line
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					x1="53.5" y1="59.63"
					x2="53.5" y2="62.26"
				/>

				<line
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					x1="60" y1="59.63"
					x2="60" y2="62.26"
				/>

				<line
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					x1="66.5" y1="59.63"
					x2="66.5" y2="62.26"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M52.18,61.5c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M58.68,61.5c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M65.18,61.5c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M71.77,61.5c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M48.32,46.78c0.22-0.29,1-0.5,1.93-0.5c0.93,0,1.71,0.21,1.93,0.5v-3c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5V46.78z"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M52.18,53.5c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					d="M47,61.35v7.41c0,2.36-1.12,3.89-1.12,3.89"
				/>
			</g>

			<g id="controls-hand-clicking">
				<path
					class="svg_fill_black svg_stroke_black svg_stroke_defs"
					d="M73.89,59.13L73.89,59.13l-2.11-2.11L68.08,60c-0.55-1.01-1.61-1.7-2.83-1.7c-1.79,0-3.25,1.47-3.25,3.27c0-1.81-1.46-3.27-3.25-3.27s-3.25,1.47-3.25,3.27L53.45,49.4c-1.79-0.8-1.21-1.05-3.01-1.05S49,50.13,49,51.94V63.3c-2.87,0-5,1.14-5,3.92v10.43c0,0.45,0.05,0.89,0.15,1.31l-0.47,0.85l2,2c0.06,0.06,0.11,0.12,0.17,0.17l0.02,0.02l0,0c1.08,1.02,2.53,1.66,4.12,1.66h18.5c3.58,0,6.5-2.95,6.5-6.55V61.57C75,60.59,74.56,59.73,73.89,59.13z"
				/>

				<path
					class="svg_fill_white svg_stroke_black svg_stroke_defs"
					d="M66.5,81.67c3.58,0,6.5-2.95,6.5-6.55V59.57c0-1.81-1.46-3.27-3.25-3.27s-3.25,1.47-3.25,3.27c0-1.81-1.46-3.27-3.25-3.27c-1.79,0-3.25,1.47-3.25,3.27c0-1.81-1.46-3.27-3.25-3.27s-3.25,1.47-3.25,3.27v-9.63c0-1.81-1.46-3.27-3.25-3.27S47,48.13,47,49.94V61.3c-2.87,0-5,1.14-5,3.92v10.43c0,3.31,2.7,6.01,6,6.01H66.5z"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					d="M47,61.3v7.43c0,2.36-1.12,3.9-1.12,3.9"
				/>

				<line
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					x1="53.5" y1="59.57"
					x2="53.5" y2="62.21"
				/>

				<line
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					x1="60" y1="59.57"
					x2="60" y2="62.21"
				/>

				<line
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					x1="66.5" y1="59.57"
					x2="66.5" y2="62.21"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M52.18,53.43c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M52.18,61.45c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M58.68,61.45c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M65.18,61.45c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs svg_stroke_thin"
					d="M71.77,61.45c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				/>
			</g>
		</SVGAnimationCommon>
	)
};

const SVGAnimationDesktop = ({ action, text_color, cell_color, grid_color, ...props }) => {
	return (
		<SVGAnimationCommon
			cell_color={cell_color}
			grid_color={grid_color}
		>
			{(action == 'opening') && (
				<g id="controls-number">
					<path
						class="svg_stroke_none"
						fill={text_color}
						d="M43.57,54.69h1.95c0.13,1.01,0.57,1.84,1.29,2.49s1.75,0.98,3.05,0.98c1.39,0,2.49-0.36,3.29-1.07c0.8-0.71,1.19-1.63,1.17-2.77c-0.02-1.13-0.43-2.03-1.24-2.7c-0.81-0.67-1.9-1-3.29-1h-1.94v-1.9h1.81c1.16,0,2.1-0.33,2.83-1c0.73-0.66,1.08-1.51,1.08-2.54c-0.01-1-0.35-1.81-1.03-2.43c-0.68-0.62-1.59-0.93-2.73-0.93c-0.61,0-1.15,0.1-1.63,0.3c-0.48,0.2-0.86,0.46-1.14,0.79c-0.28,0.33-0.5,0.68-0.65,1.04c-0.15,0.37-0.24,0.75-0.27,1.14h-2.07c0.01-0.61,0.14-1.21,0.38-1.8c0.24-0.59,0.6-1.13,1.05-1.64c0.46-0.5,1.06-0.91,1.82-1.21C48.06,40.15,48.9,40,49.82,40c1.74,0,3.15,0.46,4.22,1.38c1.08,0.92,1.63,2.08,1.67,3.48c0.03,1.26-0.34,2.33-1.1,3.2c-0.76,0.87-1.58,1.37-2.46,1.51v0.03c0.45,0.04,0.9,0.16,1.37,0.37c0.47,0.21,0.92,0.49,1.36,0.85c0.44,0.36,0.8,0.84,1.08,1.45c0.28,0.6,0.43,1.28,0.45,2.02c0.03,1.64-0.58,3-1.84,4.09C53.34,59.46,51.74,60,49.8,60c-1.94,0-3.45-0.5-4.52-1.51C44.2,57.48,43.63,56.22,43.57,54.69z"
					/>
				</g>
			)}

			<g id="controls-mouse-no-click">
				<path
					class="svg_fill_black svg_stroke_black svg_stroke_defs"
					d="M71.75,52.77l-0.55,0.92c-0.07,0-0.13-0.02-0.2-0.02H54c-2.21,0-4,1.79-4,4v24c0,1.94,0.47,3.76,1.29,5.38l-0.31,0.52l2.48,2.52l0,0c2.18,2.21,5.2,3.58,8.54,3.58h1c6.63,0,12-5.37,12-12v-24c0-0.97-0.33-1.87-0.93-2.53C73.52,54.52,71.75,52.77,71.75,52.77z"
				/>

				<path
					class="svg_fill_white"
					d="M61,91.67h-1c-6.63,0-12-5.37-12-12v-24c0-2.21,1.79-4,4-4h17c2.21,0,4,1.79,4,4v24C73,86.29,67.63,91.67,61,91.67z"
				/>

				<path
					class="svg_fill_none"
					d="M59,62.17v-8h1.5v-2.5H52c-2.21,0-4,1.79-4,4v9h12.5v-2.5H59z"
				/>

				<path
					class="svg_fill_none"
					d="M69,51.67h-8.5v2.5H62v8h-1.5v2.5H73v-9C73,53.46,71.21,51.67,69,51.67z"
				/>

				<rect
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					width="3"
					height="8"
					x="59" y="54.17"
				/>

				<line
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					x1="48" y1="64.67"
					x2="73" y2="64.67"
				/>

				<line
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					x1="60.5" y1="64.67"
					x2="60.5" y2="62.17"
				/>

				<line
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					x1="60.5" y1="51.67"
					x2="60.5" y2="54.17"
				/>

				<path
					class="svg_fill_none svg_stroke_black svg_stroke_defs"
					d="M61,91.67h-1c-6.63,0-12-5.37-12-12v-24c0-2.21,1.79-4,4-4h17c2.21,0,4,1.79,4,4v24C73,86.29,67.63,91.67,61,91.67z"
				/>
			</g>

			{(action == 'flagging') && (
				<g id="controls-mouse-right-clicking" class="controls_mouse_clicking">
					<path
						class="svg_fill_black svg_stroke_black svg_stroke_defs"
						d="M71.75,52.77l-0.55,0.92c-0.07,0-0.13-0.02-0.2-0.02H54c-2.21,0-4,1.79-4,4v24c0,1.94,0.47,3.76,1.29,5.38l-0.31,0.52l2.48,2.52l0,0c2.18,2.21,5.2,3.58,8.54,3.58h1c6.63,0,12-5.37,12-12v-24c0-0.97-0.33-1.87-0.93-2.53C73.52,54.52,71.75,52.77,71.75,52.77z"
					/>

					<path
						class="svg_fill_white"
						d="M61,91.67h-1c-6.63,0-12-5.37-12-12v-24c0-2.21,1.79-4,4-4h17c2.21,0,4,1.79,4,4v24C73,86.29,67.63,91.67,61,91.67z"
					/>

					<path
						class="svg_fill_none"
						d="M59,62.17v-8h1.5v-2.5H52c-2.21,0-4,1.79-4,4v9h12.5v-2.5H59z"
					/>

					<path
						class="svg_fill_highlight"
						d="M69,51.67h-8.5v2.5H62v8h-1.5v2.5H73v-9C73,53.46,71.21,51.67,69,51.67z"
					/>

					<rect
						class="svg_fill_none svg_stroke_black svg_stroke_defs"
						width="3"
						height="8"
						x="59" y="54.17"
					/>

					<line
						class="svg_fill_none svg_stroke_black svg_stroke_defs"
						x1="48" y1="64.67"
						x2="73" y2="64.67"
					/>

					<line
						class="svg_fill_none svg_stroke_black svg_stroke_defs"
						x1="60.5" y1="64.67"
						x2="60.5" y2="62.17"
					/>

					<line
						class="svg_fill_none svg_stroke_black svg_stroke_defs"
						x1="60.5" y1="51.67"
						x2="60.5" y2="54.17"
					/>

					<path
						class="svg_fill_none svg_stroke_black svg_stroke_defs"
						d="M61,91.67h-1c-6.63,0-12-5.37-12-12v-24c0-2.21,1.79-4,4-4h17c2.21,0,4,1.79,4,4v24C73,86.29,67.63,91.67,61,91.67z"
					/>
				</g>
			)}

			{(action == 'opening') && (
				<g id="controls-mouse-left-clicking" class="controls_mouse_clicking">
					<path
						class="svg_fill_black svg_stroke_black svg_stroke_defs"
						d="M71.75,52.77l-0.55,0.92c-0.07,0-0.13-0.02-0.2-0.02H54c-2.21,0-4,1.79-4,4v24c0,1.94,0.47,3.76,1.29,5.38l-0.31,0.52l2.48,2.52l0,0c2.18,2.21,5.2,3.58,8.54,3.58h1c6.63,0,12-5.37,12-12v-24c0-0.97-0.33-1.87-0.93-2.53C73.52,54.52,71.75,52.77,71.75,52.77z"
					/>

					<path
						class="svg_fill_white"
						d="M61,91.67h-1c-6.63,0-12-5.37-12-12v-24c0-2.21,1.79-4,4-4h17c2.21,0,4,1.79,4,4v24C73,86.29,67.63,91.67,61,91.67z"
					/>

					<path
						class="svg_fill_highlight"
						d="M59,62.17v-8h1.5v-2.5H52c-2.21,0-4,1.79-4,4v9h12.5v-2.5H59z"
					/>

					<path
						class="svg_fill_none"
						d="M69,51.67h-8.5v2.5H62v8h-1.5v2.5H73v-9C73,53.46,71.21,51.67,69,51.67z"
					/>

					<rect
						class="svg_fill_none svg_stroke_black svg_stroke_defs"
						width="3"
						height="8"
						x="59" y="54.17"
					/>

					<line
						class="svg_fill_none svg_stroke_black svg_stroke_defs"
						x1="48" y1="64.67"
						x2="73" y2="64.67"
					/>

					<line
						class="svg_fill_none svg_stroke_black svg_stroke_defs"
						x1="60.5" y1="64.67"
						x2="60.5" y2="62.17"
					/>

					<line
						class="svg_fill_none svg_stroke_black svg_stroke_defs"
						x1="60.5" y1="51.67"
						x2="60.5" y2="54.17"
					/>

					<path
						class="svg_fill_none svg_stroke_black svg_stroke_defs"
						d="M61,91.67h-1c-6.63,0-12-5.37-12-12v-24c0-2.21,1.79-4,4-4h17c2.21,0,4,1.79,4,4v24C73,86.29,67.63,91.67,61,91.67z"
					/>
				</g>
			)}
		</SVGAnimationCommon>
	)
};

const MineSweeperControls = ({ device, action, ...props }) => {
	if(device == undefined) device = 'desktop';		// "desktop" / "mobile"
	if(action == undefined) action = 'flagging';	// "flagging" / "opening"

	const theme = props?.theme ?? 'light';

	const colors = {
		bg_color:props?.bg_color ?? `rgba(${(theme == 'light') ? '255, 255, 255' : '0, 0, 0'}, 1)`,
		text_color:props?.text_color ?? `rgba(${(theme == 'light') ? '0, 0, 0' : '255, 255, 255'}, 1)`,
		cell_color:props?.cell_color ?? `rgba(${(theme == 'light') ? '0, 0, 0' : '255, 255, 255'}, 1)`,
		flag_color:props?.flag_color ?? `rgba(${props?.color_ok ?? '120, 195, 0'}, 1)`,
		grid_color:props?.grid_color ?? `rgba(${(theme == 'light') ? '0, 0, 0' : '255, 255, 255'}, 1)`,
	};

	const central_cell_size = 40;

	const Component = (device == 'mobile') ? SVGAnimationMobile : SVGAnimationDesktop;

	return (
		<div class={`minesweeper_controls gui_pos_rel is_${device} is_${action}`}>
			<Component
				device={device}
				action={action}
				{...colors}
			/>

			{(action == 'opening') && (
				<div
					class="flag_icon_controls is_fullscreen relative_to_container"
					style={{
						background:colors.bg_color,
						zIndex:'1',
					}}
				/>
			)}

			{(action == 'flagging') && (
				<div
					class="flag_icon_controls is_fullscreen relative_to_container"
					style={{
						background:colors.flag_color,
						zIndex:'1',
					}}
				>
					{(!isNotEmpty(props, 'flag_img')) ? (
						<Stage
							className="canvas_cont"
							width={central_cell_size}
							height={central_cell_size}
						>
							<Layer>
								<DefaultFlagIcon
									path_scale={central_cell_size * 0.034}
									size_portion={central_cell_size}
								/>
							</Layer>
						</Stage>
					) : (
						<div
							class="custom_flag_img"
							style={{
								backgroundImage:`url(${props.flag_img})`,
								width:`${central_cell_size}px`,
								height:`${central_cell_size}px`,
							}}
						/>
					)}
				</div>
			)}
		</div>
	)
}

export default MineSweeperControls;